import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './components/app';
import { store } from './store';

const Root = () => (
  <Provider store={store}>
    <App />
  </Provider>
);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);
root.render(<Root />);

// render(<Root />, document.getElementById("root"));
